/* global __webpack_require__ */
import * as emailsApi from '../../api/emailsApi/files';

export const getFolders = async (recordId, objectLabel, docrioNamespace = 'litify_docs') => {
  const recordFolderInfo = await emailsApi.getFolders(recordId);
  const folderMaps = {
    '': {
      path: '',
      name: `${objectLabel} Home`,
      subfolders: [],
    },
  };

  if (typeof recordFolderInfo?.[`${docrioNamespace}__Folder_Structure__c`] !== 'string') {
    return folderMaps;
  }

  const folders = JSON.parse(recordFolderInfo[`${docrioNamespace}__Folder_Structure__c`]);
  let folderQueue = [
    {
      parent: [],
      folders,
    },
  ];

  while (folderQueue.length > 0) {
    const [{ parent = [], folders }, ...nextQueue] = folderQueue;
    folderQueue = nextQueue;
    for (const folder of folders) {
      const route = [...parent, folder.name];
      const path = route.join('/');
      folder.subfolders = folder.subfolders?.map((subfolder) => ({ ...subfolder, path: `${path}/${subfolder.name}` }));
      folderMaps[path] = {
        ...folder,
        path,
      };

      if (Array.isArray(folder.subfolders) && folder.subfolders.length > 0) {
        folderQueue.push({ parent: route, folders: folder.subfolders });
      }
    }
  }

  folderMaps[''].subfolders = folders.map((folder) => folderMaps[folder.name]);

  return folderMaps;
};

export const assetPath = (() => {
  let root = '';
  try {
    root = __webpack_require__.p || ''; // eslint-disable-line
  } catch (unknownVal) {
    console.error('Failed to retrieve the root asset path. Images probably won\'t load.');
  }
  return (path) => root.substring(0, root.length - 1) + path;
})();
